import React from "react";
import { Typography, Box, useTheme } from "@mui/material";
import { themeSettings } from "../theme/theme";
import { useSelector } from "react-redux";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const mode = useSelector((state) => state.global.mode);
  return (
    <Box>
      <Typography
        variant="h2"
        color={themeSettings(mode).palette.secondary[100]}
        fontWeight={"bold"}
        sx={{ mb: "5px" }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        color={themeSettings(mode).palette.secondary[300]}
        fontWeight={"bold"}
        sx={{ mb: "5px" }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
